import { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import emailjs from '@emailjs/browser';
import { functions } from '../firebase';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HOURS = [
  { day: 'Lundi',    hours: '11h00 – 14h00  ·  18h00 – 23h00' },
  { day: 'Mardi',    hours: '11h00 – 14h00  ·  18h00 – 23h00' },
  { day: 'Mercredi', hours: '11h00 – 14h00  ·  18h00 – 23h00' },
  { day: 'Jeudi',    hours: '11h00 – 14h00  ·  18h00 – 23h00' },
  { day: 'Vendredi', hours: '11h00 – 14h00  ·  18h00 – 23h00' },
  { day: 'Samedi',   hours: '18h00 – 23h00' },
  { day: 'Dimanche', hours: '18h00 – 22h00' },
];

function InstagramIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  );
}


const labelStyle = {
  fontFamily: 'Jane Light, sans-serif',
  fontSize: '12px',
  fontWeight: '600',
  color: '#4A4A4A',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  display: 'block',
  marginBottom: '6px',
};

const inputStyle = {
  width: '100%',
  fontFamily: 'Jane Light, sans-serif',
  fontSize: '14px',
  color: '#000',
  padding: '12px 14px',
  borderRadius: '8px',
  border: '1.5px solid #e0e0e0',
  outline: 'none',
  boxSizing: 'border-box',
  backgroundColor: '#fff',
};

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Contact — Four A Tacos';
  }, []);

  const [form, setForm] = useState({
    nature: '',
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    commentaire: '',
    rgpd: false,
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const set = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const canSubmit = form.nature && form.nom.trim() && form.prenom.trim() && form.email.trim() && form.rgpd && !loading;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setLoading(true);
    setError('');
    try {
      const submitContact = httpsCallable(functions, 'submitContact');
      await submitContact({
        nature: form.nature,
        nom: form.nom.trim(),
        prenom: form.prenom.trim(),
        email: form.email.trim(),
        telephone: form.telephone.trim(),
        commentaire: form.commentaire.trim(),
      });
    } catch (err) {
      setError('Une erreur est survenue. Veuillez réessayer.');
      setLoading(false);
      return;
    }

    try {
      const templateParams = {
        subject: `Nouveau message de contact - ${form.nature}`,
        nom: form.nom.trim(),
        prenom: form.prenom.trim(),
        email: form.email.trim(),
        telephone: form.telephone.trim() || 'Non renseigné',
        commentaire: form.commentaire.trim() || 'Aucun commentaire',
      };
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );
    } catch (err) {
      console.error('[EmailJS] error:', err);
      setError(`Erreur EmailJS : ${err?.text || err?.message || JSON.stringify(err)}`);
      setLoading(false);
      return;
    }

    setSuccess(true);
    setForm({ nature: '', nom: '', prenom: '', email: '', telephone: '', commentaire: '', rgpd: false });
    setLoading(false);
  };

  const todayIndex = new Date().getDay();
  const todayName = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'][todayIndex];

  return (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />

      <main style={{ paddingTop: '80px', boxSizing: 'border-box', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

          {/* Titre */}
          <div className="contact-header" style={{ maxWidth: '1100px', margin: '0 auto', padding: '32px 48px 0', boxSizing: 'border-box' }}>
            <h1 className="contact-title" style={{ fontFamily: 'Code Pro Black, sans-serif', fontSize: '52px', fontWeight: '400', color: '#000', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 4px 0' }}>
              Nous contacter
            </h1>
          </div>

          {/* Layout 2 colonnes */}
          <div className="contact-grid" style={{ alignItems: 'start' }}>

            {/* Formulaire */}
            <div style={{ backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e5e5e5', padding: '32px' }}>

              {success ? (
                <div style={{ textAlign: 'center', padding: '40px 0' }}>
                  <div style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: '#C10230', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                    <span style={{ color: '#fff', fontSize: '26px' }}>✓</span>
                  </div>
                  <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '16px', fontWeight: '700', color: '#000', margin: '0 0 8px 0' }}>Message envoyé !</p>
                  <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '14px', color: '#888', margin: '0 0 24px 0' }}>Nous vous répondrons dans les plus brefs délais.</p>
                  <button
                    onClick={() => setSuccess(false)}
                    style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '600', color: '#C10230', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}
                  >
                    Envoyer un autre message
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>

                  {/* Nature */}
                  <div>
                    <label style={labelStyle}>Nature de la requête *</label>
                    <input type="text" value={form.nature} onChange={e => set('nature', e.target.value)} placeholder="" style={inputStyle} />
                  </div>

                  {/* Nom + Prénom */}
                  <div className="contact-name-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                    <div>
                      <label style={labelStyle}>Nom *</label>
                      <input type="text" value={form.nom} onChange={e => set('nom', e.target.value)} placeholder="" style={inputStyle} />
                    </div>
                    <div>
                      <label style={labelStyle}>Prénom *</label>
                      <input type="text" value={form.prenom} onChange={e => set('prenom', e.target.value)} placeholder="" style={inputStyle} />
                    </div>
                  </div>

                  {/* Email */}
                  <div>
                    <label style={labelStyle}>Adresse e-mail *</label>
                    <input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="" style={inputStyle} />
                  </div>

                  {/* Téléphone */}
                  <div>
                    <label style={labelStyle}>Téléphone</label>
                    <input type="tel" value={form.telephone} onChange={e => set('telephone', e.target.value)} placeholder="" style={inputStyle} />
                  </div>

                  {/* Commentaire */}
                  <div>
                    <label style={labelStyle}>Commentaires</label>
                    <textarea
                      value={form.commentaire}
                      onChange={e => set('commentaire', e.target.value)}
                      placeholder=""
                      rows={5}
                      style={{ ...inputStyle, resize: 'vertical', minHeight: '120px' }}
                    />
                  </div>

                  {/* RGPD */}
                  <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={form.rgpd}
                      onChange={e => set('rgpd', e.target.checked)}
                      style={{ marginTop: '2px', accentColor: '#C10230', width: '16px', height: '16px', flexShrink: 0, cursor: 'pointer' }}
                    />
                    <span style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#4A4A4A' }}>
                      J'accepte que mes données soient traitées conformément à la{' '}
                      <a href="/politique-confidentialite" target="_blank" rel="noreferrer" style={{ color: '#C10230', fontWeight: '600' }}>
                        politique de confidentialité
                      </a>
                    </span>
                  </label>

                  {/* Erreur */}
                  {error && (
                    <div style={{ backgroundColor: '#fff3f3', border: '1px solid #f5c6c6', borderRadius: '8px', padding: '12px 14px' }}>
                      <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#C10230', margin: 0 }}>{error}</p>
                    </div>
                  )}

                  {/* Submit */}
                  <button
                    type="submit"
                    disabled={!canSubmit}
                    style={{ alignSelf: 'center', fontFamily: 'Jane Light, sans-serif', fontSize: '14px', fontWeight: '700', color: '#fff', backgroundColor: canSubmit ? '#C10230' : '#ccc', padding: '14px 40px', borderRadius: '10px', border: 'none', cursor: canSubmit ? 'pointer' : 'not-allowed', textTransform: 'uppercase', letterSpacing: '1px', marginTop: '4px', opacity: loading ? 0.7 : 1 }}
                  >
                    {loading ? 'Envoi en cours...' : 'Envoyer'}
                  </button>

                </form>
              )}
            </div>

            {/* Infos */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>

              {/* Adresse + téléphone */}
              <div>
                <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '11px', fontWeight: '700', color: '#C10230', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 12px 0' }}>Adresse</p>
                <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '14px', color: '#4A4A4A', lineHeight: '1.8', margin: '0 0 16px 0' }}>
                  303 Rue de la République<br />73000 Chambéry
                </p>
                <a href="tel:0422910537" style={{ display: 'block', fontFamily: 'Jane Light, sans-serif', fontSize: '14px', fontWeight: '600', color: '#C10230', textDecoration: 'none', marginBottom: '4px' }}>04 22 91 05 37</a>
                <a href="tel:0621961492" style={{ display: 'block', fontFamily: 'Jane Light, sans-serif', fontSize: '14px', fontWeight: '600', color: '#C10230', textDecoration: 'none' }}>06 21 96 14 92</a>
              </div>

              {/* Horaires */}
              <div>
                <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '11px', fontWeight: '700', color: '#C10230', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 12px 0' }}>Horaires</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                  {HOURS.map(({ day, hours }) => {
                    const isToday = day === todayName;
                    return (
                      <div key={day} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
                        <span style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: isToday ? '700' : '400', color: isToday ? '#000' : '#4A4A4A' }}>
                          {day}
                        </span>
                        <span style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: isToday ? '700' : '400', color: isToday ? '#000' : '#4A4A4A' }}>
                          {hours}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Réseaux sociaux */}
              <div>
                <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '11px', fontWeight: '700', color: '#C10230', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 12px 0' }}>Suivez-nous</p>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <a href="https://www.instagram.com/fouratacos" target="_blank" rel="noopener noreferrer" style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', textDecoration: 'none' }}>
                    <InstagramIcon />
                  </a>
                  <a href="https://www.facebook.com/fouratacos" target="_blank" rel="noopener noreferrer" style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', textDecoration: 'none' }}>
                    <FacebookIcon />
                  </a>
                  <a href="https://snapchat.com/t/C5QxIHpY" target="_blank" rel="noopener noreferrer" style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }}>
                    <img src="/snapchat.png" alt="Snapchat" style={{ width: '22px', height: '22px', objectFit: 'contain', display: 'block', filter: 'brightness(0) invert(1)' }} />
                  </a>
                </div>
              </div>

            </div>
          </div>
      </main>

      <Footer />
    </div>
  );
}
